import { green } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import objImg from "assets/images/BgImage.png";
export default makeStyles(({ functions, borders, breakpoints }) => {
  const { pxToRem } = functions;
  const { borderRadius } = borders;

  return {
    pageLayout: {
      padding: `${pxToRem(16)} ${pxToRem(28)}`,
      // display: "flex",
      // justifyContent: "center",
      // alignItems: "center",
      // position: "relative",
      background: `url(${objImg}) no-repeat left top`,
      backgroundSize: "cover",
    },
    coverLayout: {
      margin: 0,
    },
    logo: {
      maxWidth: pxToRem(280),
    },
    coverLayout_formBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    coverLayout_item: {
      width: "100%",
      maxWidth: pxToRem(500),
      borderRadius: pxToRem(16),
      zIndex: 1,
      backgroundColor: "#fff",
      padding: `${pxToRem(28)} ${pxToRem(38)}`,

    },
    imageBox: {
      width: "100%",
      height: "100%",
      [breakpoints.down("xl")]: {
        position: "absolute",
        padding: pxToRem(10),
        zIndex: 0,
      },
    },
    coverLayout_imageBox: {
      height: "100%",
      overflow: "hidden",
      borderRadius: borderRadius.xl,
    },

    coverLayout_image: {
      backgroundImage: ({ image }) => `url(${image})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      height: "100%",
      [breakpoints.down("xl")]: {
        backgroundPosition: "center",
      },
    },
  };
});
